import { render, staticRenderFns } from "./select-role.vue?vue&type=template&id=521cef86&scoped=true&"
import script from "./select-role.vue?vue&type=script&lang=js&"
export * from "./select-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521cef86",
  null
  
)

export default component.exports